import Glide from '@glidejs/glide';
export class CoasCarrousel {
    constructor(_carrouselId, _config, fnRunSlides) {
        this._config = _config;
        this.fnRunSlides = fnRunSlides;
        this.carrouselId = _carrouselId;
    }
    onInit() {
        this.glide = this.newGlide();
        this.glide.on('mount.after', () => {
            this.fnRunSlides && this.fnRunSlides();
        });
        this.fnRunSlides && this.glide.on('run.after', () => {
            this.fnRunSlides && this.fnRunSlides();
        });
        this.glide.mount();
    }
    getInstance() {
        return this.glide;
    }
    newGlide() {
        return new Glide(`#${this.carrouselId}`, this._config);
    }
}
